import { useState } from 'react';
import { Grid, Typography, Button, Modal, Box, TextField } from '@mui/material';
import swal from 'sweetalert';
import { collection, addDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../../firebaseConfig/firebase';

const style = {
  width: '80%',
  height: 'auto',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 700,
  backgroundColor: 'black',
  padding: 4,
};

const AddProducts = () => {
  // campos firebase
  const [name, setName] = useState('');
  const [price, setPrice] = useState(0);
  const [stock, setStock] = useState(30);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // inicializamos la coleccion.
  const productscollection = collection(db, 'products');
  /* Pusimos el agregado de la imagen al storage, la url de la imagen y 
agregamos los campos con swal todo en la misma funcion, es la unica manera
en la que me funciono. yo queria hacerlo x separado.

/* file: es el archivo que sube el usuario 
ref: es la referencia en la que decimos donde se va a guardar la imagen en
el storage. en este caso dentro de la carpeta products y se va a guardar
con el nombre del archivo que tenga el usuario. tambien se puede guardar
con un id. OJO si el id es estatico y subimos 2 imagenes firebase elimina
la img anterior y solo deja la mas actual para mantener un id unico por
cada imagen. para q el id sea dinamico usamos: UUID para generar ids
dinamicos automaticamente. parea eso ponemos `/Products/${v4()}` ese v4
genera un id dinamico para cada imagen.
uploadBytes: sirve para subir el archivo, hay muchas formas de subirlo.
nosotros usamos el blob of file en el que vos solo seleccionas el archivo
y firebase lo sube. tmb lo podes subir en formato de bites o en base64 y
row string. con este upload seleccionamos el archivo para su posterior
subida
para subir la imagen o archivo ponemos: 
onChange={(e) => uploadFile(e.target.files[0])}
getDownloadUrl: Sirve para obtener la url de la imagen que esta en el 
storage, esa url la pasamos a la database para mostrarla en las cards */
  const uploadFile = async (file) => {
    const storageRef = ref(storage, `/Products/${file.name}`);
    await uploadBytes(storageRef, file);
    const img = await getDownloadURL(storageRef);
    addDoc(productscollection, { name, price, img, stock })
      .then(swal('Good job!', 'Product has been added !', 'success'))
      .catch((err) => swal(err.message));
    setOpen(false);
    console.log(img);
  };
  const addProducts = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <Grid
        style={{
          height: '20vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      />
      <Button onClick={handleOpen} variant="contained">
        Add
      </Button>
      <Modal
        style={{ padding: '40px' }}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            item
          >
            <Button variant="contained" onClick={handleClose}>
              X
            </Button>
          </Grid>
          <Typography style={{ textAlign: 'center', color: '#fff' }} id="modal-modal-title" variant="h3" component="h2">
            Add Product
          </Typography>
          <form
            onSubmit={addProducts}
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <TextField
              type="text"
              style={{ width: '80%', margin: '15px', backgroundColor: '#fff' }}
              id="outlined-basic"
              label="Name"
              variant="outlined"
              required
              onChange={(e) => setName(e.target.value)}
            />

            <TextField
              type="number"
              style={{ width: '80%', margin: '15px', backgroundColor: '#fff' }}
              id="outlined-basic"
              label="Price"
              variant="outlined"
              required
              onChange={(e) => setPrice(e.target.value)}
            />
            <TextField
              type="file"
              style={{ width: '80%', margin: '15px', backgroundColor: '#fff' }}
              id="outlined-basic"
              label="Img"
              variant="outlined"
              required
              // con [0] te da info de la ultima imagen q pongamos
              onChange={(e) => uploadFile(e.target.files[0])}
            />
            <TextField
              type="number"
              style={{ width: '80%', margin: '15px', backgroundColor: '#fff' }}
              id="outlined-basic"
              label="Stock"
              variant="outlined"
              disabled="true"
              value={stock}
              onChange={(e) => setStock(e.target.value)}
            />

            <input
              style={{
                margin: '10px',
                padding: '15px',
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                fontWeight: 600,
                width: '40%',
                borderRadius: '3px',
                cursor: 'pointer',
              }}
              type="submit"
              value="Add"
            />
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default AddProducts;
